var CpsPassportData = window.CpsPassportData = (function () {

    function HandleVideoCallDatepickerChange(date, datepicker) {
        Ajax.postJson("/account/profile/edit/getactualtimespans", {
            data: { dateTime: date },
            success: function (resp) {
                var selectNode = $('#VideoConferenceRequestTimespan,#VideoConferenceModel_VideoConferenceRequestTimespan');

                selectNode.empty();
                $.each(resp.items, function (key, value) {
                    selectNode.append($("<option></option>").attr("value", value.Value).text(value.Text));
                });
                selectNode.niceSelect('update');
            }
        });
    }

    function HandleVideoCallDatepickerChangeMobile(datepicker) {
        if (datepicker.value != "") {
            Ajax.postJson("/account/profile/edit/getactualtimespans", {
                data: { dateTime: datepicker.value },
                success: function (resp) {
                    var selectNode = $('#VideoConferenceRequestTimespan,#VideoConferenceModel_VideoConferenceRequestTimespan');

                    selectNode.empty();
                    $.each(resp.items, function (key, value) {
                        selectNode.append($("<option></option>").attr("value", value.Value).text(value.Text));
                    });
                    selectNode.niceSelect('update');
                }
            });
        }
    }
    function beforeDatepickerShow(input, instance) {
        input = $(input);
        instance.dpDiv.addClass('m-cps-reg-form');

        let inputOffset = input.offset();

        setTimeout(function () {
            instance.dpDiv.css({
                left: inputOffset.left - input.outerWidth() + 90 + 'px',
                top: inputOffset.top - instance.dpDiv.height() / 2 + 20 + 'px'
            });
        }, 1);
    }

    function initCpsComparisonMasks() {
        $(document).on('change', '#comparisonDocType', function () {
            var value = $(this).val();

            if (value === window.Localization.getString('Scripts_cps.passport-data_0', 'ПаспортРФ')) {
                $('#seriesContainer').show();
                $('#numberContainer').show();
                $('#comparisonSeries').inputmask('9999');
                $('#comparisonNumber').inputmask('999999');
            }
            if (value === window.Localization.getString('Scripts_cps.passport-data_1', 'ПаспортИностранногоГосударства')) {
                $('#seriesContainer').hide();
                $('#comparisonSeries').inputmask('remove');
                $('#comparisonNumber').inputmask('remove');
            }
        });
    }
    function initVideoConfTypeInputs() {
        $(document).on('change', '#videoType', function () {
            $('[name$=ConferenceIdentity]').val('');
            var conferenceType = $(this).val();
            switch (conferenceType) {
                case "Viber":
                case "Whatsapp":
                    $('[name$=ConferenceIdentity]').inputmask('+7 (999) 999-99-99');
                    break;
                case "Skype":
                    $('[name$=ConferenceIdentity]').inputmask('');
                    break;
            }
        });

        $('#videoType').change();
    }

    function initDocTypeInputs() {
        if ($('#DocType').val() == 'RussianPassport') {
            $('#DocNumber').inputmask('999999').attr('maxlength', 50);
            $('#DocSeries').inputmask('9999');
            $('#Document_DocumentAuthorityCode').inputmask('999-999');
            $('#additionalDocumentContainer').hide();
            $('#docTillDate').hide();
            $('#citizenShipSelect').hide();
            $('#citizenshipDropdown').val('RU');
        }

        var fullConferenceType = $('#videoType').val();

        if (fullConferenceType == 'Viber' || fullConferenceType == 'Whatsapp') {
            $('#ConferenceIdentity').inputmask('+7 (\\999)-999-99-99');
            $('#VideoConferenceModel_ConferenceIdentity').inputmask('+7 (\\999)-999-99-99');
        }
        else {
            $('#ConferenceIdentity').inputmask('remove');
            $('#VideoConferenceModel_ConferenceIdentity').inputmask('remove');
        }

        $(document).on('change', '#videoType', function () {
            var value = $(this).val();

            if (value == 'Viber' || value == 'Whatsapp') {
                $('#ConferenceIdentity').inputmask('+7 (\\999)-999-99-99');
                $('#VideoConferenceModel_ConferenceIdentity').inputmask('+7 (\\999)-999-99-99');
            }
            else {
                $('#ConferenceIdentity').inputmask('remove');
                $('#VideoConferenceModel_ConferenceIdentity').inputmask('remove');
            }
        });
        initVideoConfTypeInputs();

        $(document).on('change', '#DocType', function () {
            var docNumberInput = $('#DocNumber');
            var docSeriesInput = $('#DocSeries');

            if ($('#DocType option:selected').val() == 'RussianPassport') {
                $('#codeWordContainer').show();
                $('#hidderForeignError').hide();

                if (docNumberInput && docNumberInput.is(':visible')) {
                    docNumberInput.inputmask('999999');
                }

                if (docSeriesInput && docSeriesInput.is(':visible')) {
                    docSeriesInput.inputmask('9999');
                }

                $('#Document_DocumentAuthorityCode').inputmask('999-999');

                $('#authorityCode').show();
            }
            else {

                if (!$('#is-foreign-passport-registration-avaliable').val()) {
                    $('#codeWordContainer').hide();
                    $('#hidderForeignError').show();
                }

                if (docNumberInput && docNumberInput.is(':visible')) {
                    docNumberInput.val('');
                    docNumberInput.inputmask('remove');
                }

                if (docSeriesInput && docSeriesInput.is(':visible')) {
                    docSeriesInput.val('');
                    docSeriesInput.inputmask('remove');
                }

                $('#authorityCode').hide();
            }
        });

        $(document).on('change', '#DocType', function () {

            var taggedField = $('#tagged');

            if ($('#DocType option:selected').val() == 'RussianPassport') {
                $('#citizenshipDropdown').val('RU');
                $('#citizenShipSelect').hide();

                taggedField.addClass("m-tagged");
            }
            else {
                $('#citizenShipSelect').show();

                taggedField.removeClass("m-tagged");
            }
        });
    }

    return {
        HandleVideoCallDatepickerChange,
        HandleVideoCallDatepickerChangeMobile,
        beforeDatepickerShow,
        initCpsComparisonMasks,
        initVideoConfTypeInputs,
        initDocTypeInputs,

    }
}());